import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import axiosInstance from '../utils/axiosInstance';
import * as XLSX from 'xlsx';
import './search.css';

function Search ( {authenticatedUser, isLoading, isAdmin, setAdmin} ) {
    const navigate = useNavigate();

    const getInitialAreaState = () => {
        const value = "";
        return value;
    };
    const getInitialSortByState = () => {
        let value = {value: "Total Refund", label: "Total Refund"};
        if(sessionStorage.getItem('sortBy') !== null)
            
            value = JSON.parse(sessionStorage.getItem('sortBy'))
        //console.log("changing sortBy value to local: " + JSON.stringify(value, null, 2))
        return value;
    };
    const getInitialSortDirState = () => {
        let value = {value: "DESC", label: "DESC"};
        if(sessionStorage.getItem('sortDir') !== null)
            value = JSON.parse(sessionStorage.getItem('sortDir'))
        return value;
    };

    const getInitialAreas = () => {
        let value = [{value: "", label: "ALL AREAS", exclusive: 1}]
        if(sessionStorage.getItem('areas') !== null)
            //value = JSON.parse(options.filter( item => item.label !== "ALL AREAS").concat(JSON.parse(sessionStorage.getItem('areas'))))
            value = JSON.parse(sessionStorage.getItem('areas'))
        return value;
    };

    const getInitialSelectedAreas = () => {
        let value = [{value: "", label: "ALL AREAS", exclusive: 1}]
        if(sessionStorage.getItem('areaSelect') !== null)
            value = JSON.parse(sessionStorage.getItem('areaSelect'))
        return value;
    };

    const getInitialRefund = () => {
        let refund = []
        if(sessionStorage.getItem('refunds') !== null)
            refund = JSON.parse(sessionStorage.getItem('refunds'))
        //console.log("changing refund value to local: " + JSON.stringify(refund, null, 2))
        return refund;
    }

    const [refunds, setRefunds] = useState(getInitialRefund);
    const [descriptions, setDescriptions] = useState([]);

    const columnNames = [{value: "Total Refund", label: "Total Refund"}, {value: "HC Expiring", label: "HC Expiring"}, {value: "HighCost", label: "HighCost"}, {value: "LowPro", label: "LowPro"}, {value: "A-Z", label: "A-Z"}, {value: "New Drills", label: "New Drills"}];
    const [sortBy, setSortBy] = useState(getInitialSortByState);

    const sortOpt = [{value: "ASC", label: "ASC"}, {value: "DESC", label: "DESC"}];
    const [sortDir, setSortDir] = useState(getInitialSortDirState);
    
    const [value, setValue] = useState(getInitialAreaState);
    const [options, setOptions] = useState(getInitialAreas)
    
    const [selectedOptions, setSelectedOptions] = useState(getInitialSelectedAreas);

    const [input, setInput] = useState('');
    const [gettingResults, setGettingResults] = useState(true);

    const customStyles = {
        control: (provided) => ({
            ...provided,
            display: 'inline-flex', // or 'inline-flex'
            width: 'auto', // Adjust as needed
            marginRight: '10px',
        }),
        option: (base) => ({ ...base, color: 'black' }),
        menu: (provided) => ({
            ...provided,
            width: 'max-content',
            minWidth: '100%',
          }),
    };

    useEffect(() => { 
        //setRefunds(getInitialRefund);
        //console.log('stored refunds: ' + localStorage.getItem('refunds'))
        /*if(sessionStorage.getItem('refunds') !== null)
            setGettingResults(true)
            //setOptions(JSON.parse(sessionStorage.getItem('areas')));
            //setSelectedOptions(JSON.parse(sessionStorage.getItem('areaSelect')))
            //setSortBy(JSON.parse(sessionStorage.getItem('sortBy')))
            //setSortDir(JSON.parse(sessionStorage.getItem('sortDir')))*/
        setGettingResults(false)
        if(sessionStorage.getItem('refunds') === null) {
            //console.log("clearing search")
            clearSearch();
        }
            
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]); 

    useEffect(() => {
        if(authenticatedUser === null){
            //console.log('authenticatedUser is null sending to login page')
            navigate("/login");
        }

        const getAdminState = async() => {
        await axiosInstance.get('/checkAdmin', {withCredentials:true} )
        .then(response => {
            setAdmin(response.data.isAdmin)
        })
        .catch(error => {
            setAdmin(false)
            console.log(error)
        });
        };
    
        getAdminState();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authenticatedUser]);

    useEffect(() => {
        setValue('');
        setValue( selectedOptions.map(areaObj => areaObj.value).join(",") );

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedOptions]);

    const getTaxpayer = async() => {
        setGettingResults(true);
        console.log("searching for specific refunds")
        await axiosInstance.post('/searchRefundsAndArea', {data: {area: value, tpName: input, sortBy: sortBy.value, sortDir: sortDir.value}}, {withCredentials:true})
        .then(response => {
            setRefunds(response.data[0]);
            sessionStorage.setItem('refunds', JSON.stringify(response.data[0]));
            //console.log('setting local' + localStorage.getItem('refunds'));
            setGettingResults(false);
        })
        .catch(error => console.error('Error fetching refunds:', error));
    };

    const clearSearch = async() => {
        console.log("getting initial search page refunds")
        setGettingResults(true);
        setInput('');
        setValue("");
        setSortBy({value: "Total Refund", label: "Total Refund"});
        setOptions([{value: "", label: "ALL AREAS", exclusive: 1}])
        await axiosInstance.get('/getRefunds', {withCredentials:true})
        .then(response => {
            setRefunds(response.data[0]);
            sessionStorage.setItem('refunds', JSON.stringify(response.data[0]))
            //console.log('setting local' + localStorage.getItem('refunds'))
            setDescriptions(response.data[1]);
            if(response.data[2] !== null)
                setOptions(options.concat(response.data[2].map( ( areaObj ) => ({ value: areaObj.Area, label: areaObj.Area, exclusive: areaObj.Exclusive}) )));
                sessionStorage.setItem('areas', JSON.stringify(options.concat(response.data[2].map( ( areaObj ) => ({ value: areaObj.Area, label: areaObj.Area, exclusive: areaObj.Exclusive}) ))))
            setGettingResults(false);
        })
        .catch(error => console.error('Error fetching refunds:', error));
    };

    const clickMe = (data) => {
        navigate("/taxpayer", { state: {data: data} });
    }

    const handleAreaDropDownChangeTwo = (selected, action) => {
        if (action.action === 'select-option' && selected.find(option => option.exclusive === 1)) {
            setSelectedOptions([selected.find(option => option.exclusive === 1)]);
            sessionStorage.setItem('areaSelect', JSON.stringify([selected.find(option => option.exclusive === 1)]))
        } else {
            setSelectedOptions(selected);
            sessionStorage.setItem('areaSelect', JSON.stringify(selected))
        }
    };

    const handleSortByDropDownChange = (selectedSortBy) => {
        setSortBy(selectedSortBy);
        sessionStorage.setItem('sortBy', JSON.stringify(selectedSortBy))
    };

    const handleSortDirDropDownChange = (selectedSortDir) => {
        setSortDir(selectedSortDir);
        sessionStorage.setItem('sortDir', JSON.stringify(selectedSortDir))
    }
    
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            getTaxpayer();
        }
    };
    
    const exportToExcel = () => {
        const exportSearch = refunds.map( ({LowPro, HighCost, TwoYrInactive, RefundExpiring, Refund, ...rest}) => ({ ...rest}) );
        
        var ws = XLSX.utils.json_to_sheet(exportSearch);
        var ws2 = XLSX.utils.json_to_sheet(descriptions)
        /* create workbook and export */
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "MktReport");
        XLSX.utils.book_append_sheet(wb, ws2, "Descriptions");
        XLSX.writeFile(wb, "MarketingReport.xlsx");
    };

    if(gettingResults){
        return <div className="search-app"> <h1>Loading Search Page...</h1> </div>
    }
    
    return (
        <div className="search-app">
                
            <h1>Marketing Report</h1>
            <p>Disclaimer: All information contained herein is proprietary to T-COT and is provided solely for the purpose of obtaining a contract with T-COT. Unauthorized use, disclosure, or distribution of this information is strictly prohibited. Any other use of this information without the express written consent of T-COT is not permitted.</p>

            <div className="taxpayer-input">

                <p>Filter By: </p>
                <input type="text" id = "inputvalue" value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={handleKeyPress} placeholder={"Taxpayer Name"} />

                <Select
                    className="area-select"
                    isClearable={false}
                    isSearchable//={false}
                    isMulti 
                    styles={customStyles}
                    controlShouldRenderValue={false}
                    hideSelectedOptions={false}
                    closeMenuOnSelect={false}
                    placeholder="Areas"
                    defaultValue={options[0]}
                    options={options}
                    value={selectedOptions} //new thing here
                    onChange={handleAreaDropDownChangeTwo}
                /> 

                <p>Sort By: </p>

                <Select
                    className="sort-select"
                    isClearable={false}
                    styles={customStyles}
                    onChange={handleSortByDropDownChange}
                    defaultValue={columnNames[0]}
                    value={sortBy}
                    options={columnNames} 
                />

                <Select
                    className="order-select"
                    isClearable={false}
                    styles={customStyles}
                    onChange={handleSortDirDropDownChange}
                    defaultValue={sortOpt[1]}
                    value={sortDir}
                    options={sortOpt} 
                /> 
                
                <button onClick={getTaxpayer}>Search</button>
                
                <button onClick={clearSearch} className="clearSearch">Clear Search</button>

                {isAdmin &&
                <button onClick={exportToExcel}>Export</button>}
                
            </div>
            
            {refunds.length === 0 && <h1>No Results Found</h1>}
            
            {refunds.length > 0 && 
            <table className="totalRefund-table">
                <tbody>
                    <tr>
                        <th width="650.48px">TaxpayerName</th>
                        <th width="150.17px">Area</th>
                        <th width="122.34px">LowPro</th>
                        <th width="122.34px">High Cost</th>
                        <th width="122.34px">Two Year Inactive</th>
                        <th width="122.34px">LP/HC Expiring</th>
                        <th width="122.34px">Total Refund</th>
                        <th width="122.34px">New Drills</th>
                    </tr>
                    
                    {refunds.map((refundForTP, i) => (
                        <tr height="58px" key={refundForTP.TaxpayerNumber}>
                            <td>
                                <button onClick={() => clickMe({TPNumber: refundForTP.TaxpayerNumber})} className="ViewDetailsBtnLink">{refundForTP.TaxpayerName}</button>
                            </td>
                            <td>
                                {refundForTP.Area}
                            </td>
                            <td>
                                {refundForTP.LowPro}
                            </td>
                            <td>
                                {refundForTP.HighCost}
                            </td>
                            <td>
                                {refundForTP.TwoYrInactive}
                            </td>
                            <td>
                                {refundForTP.RefundExpiring}
                            </td>
                            <td>
                                {refundForTP.Refund}
                            </td>
                            <td>
                                {refundForTP.NewWellsDrilled}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>}
            

        </div>
    );
};
 
export default Search;